import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    icon: {
        fill: theme.palette.primary.main,
    },
}));
